function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgPermit(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M27,1a4,4,0,0,1,4,4V27a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V5A4,4,0,0,1,5,1H27m0-1H5A5,5,0,0,0,0,5V27a5,5,0,0,0,5,5H27a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    style: {
      fill: "#0074d9"
    }
  }), React.createElement("path", {
    d: "M14.38,23H8.79a2.3,2.3,0,0,1-2.29-2.3V11.33A2.29,2.29,0,0,1,8.79,9H23.21a2.29,2.29,0,0,1,2.29,2.29v9.41A2.3,2.3,0,0,1,23.21,23",
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 9.95,
    y1: 12.87,
    x2: 21.95,
    y2: 12.87,
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 9.95,
    y1: 15.87,
    x2: 12.95,
    y2: 15.87,
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("circle", {
    cx: 18.79,
    cy: 19.34,
    r: 3,
    style: {
      fill: "none",
      stroke: "#6e7482",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("polyline", {
    points: "20.95 21.82 20.95 27.03 18.87 25.02 16.95 27.03 16.95 21.82",
    style: {
      fill: "#6e7482"
    }
  }))));
}

export default __webpack_public_path__ + "static/media/permit.08476db8.svg";
export { SvgPermit as ReactComponent };